module.exports = __webpack_public_path__ + "img/logo-black.513da678.png";